import React, { useState } from "react";

import EditIcon from '@mui/icons-material/Edit';
import { Delete } from "@mui/icons-material";

import DialogModifyUsuario from '../Usuarios/DialogModifyUsuario'

import { TableRow, TableCell, IconButton, Box, Button, DialogActions, DialogContentText, Dialog, DialogTitle, DialogContent, Typography } from "@mui/material";

const RowTableUsuarios = ({data, handleDelete, handleUpdateData, areUserAdmin, searchHighlighted}) => {
  const [open, setOpen] = useState(false);
  const [openAlertDelete, setOpenAlertDelete] = useState(false);

  const [openModifyDialog, setOpenModifyDialog] = useState(false);
  
  const handleOpenModifyDialog = () => { setOpenModifyDialog(true) }
  const handleCloseModifyDialog = () => { setOpenModifyDialog(false) }

  return (
    <React.Fragment>
      { areUserAdmin && <Dialog
        open={openAlertDelete}
        keepMounted
        onClose={() => {setOpenAlertDelete(false)}}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Espera un Segundo!"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            ¿Está seguro de eliminar este usuario? Esta operación es destructiva y permanente.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {setOpenAlertDelete(false)}} color='error' variant="outlined">No</Button>
          <Button onClick={() => {setOpenAlertDelete(false); handleDelete(data.id); }} color='primary' variant="contained">¡Sí!</Button>
        </DialogActions>
      </Dialog>}

      <TableRow sx={{ backgroundColor: searchHighlighted ? 'action.selected' : undefined }}>
        <TableCell component="th" scope="row" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd' }}> {data.id} </TableCell>
        <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd' }}> {data.nombre} </TableCell>
        <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd', borderRight: areUserAdmin ? null : '2px solid #ddd'}}> {data.rol} </TableCell>
        {areUserAdmin && <TableCell sx={{ borderLeft: '2px solid #ddd', borderRight: '2px solid #ddd', borderBottom: '2px solid #ddd'}}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <IconButton
                size="large"
                onClick={() => {handleOpenModifyDialog()}}
                sx={{ color: '#33eaff', padding: 0, border: '2px solid #33eaff' }}
              >
                <EditIcon sx={{ fontSize: '33px' }}/>
              </IconButton>
              <IconButton
                size="large"
                onClick={() => { setOpenAlertDelete(true) }} // Se ejecuta la eliminación
                sx={{ color: '#d32f2f', padding: 0, border: '2px solid #d32f2f' }}
              >
                <Delete sx={{ fontSize: '33px' }}/>
              </IconButton>
          </Box>
        </TableCell>}
      </TableRow>
      {areUserAdmin && <DialogModifyUsuario openDialog={openModifyDialog} handleCloseDialog={handleCloseModifyDialog} handleUpdateData={handleUpdateData} data={data}/>}

    </React.Fragment>
  );
}

export default RowTableUsuarios;
